/** @format */

import "./App.css";
import NotFound from "./pages/404.jsx";
import AboutPage from "./pages/About.jsx";
import IndexPage from "./pages/Index.jsx";
import JoinPage from "./pages/Join.jsx";
import { Analytics } from "@vercel/analytics/react";

import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<IndexPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/join" element={<JoinPage />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
